import React from 'react';
import { FileSpreadsheet, ArrowLeft, Eye, Undo2, CheckCircle2 } from 'lucide-react';
import Reveal from './Reveal';

const POINTS = [
  { icon: Eye, title: 'معاينة قبل الاستيراد', text: 'نعرض لك كل فئة ولاعب واشتراك سنُنشئه، مع تنبيه لأي بيانات ناقصة — قبل حفظ أي شيء.' },
  { icon: CheckCircle2, title: 'فئات واشتراكات ومتأخرات', text: 'نقرأ الفئات العمرية وتواريخ الاشتراك والمدفوعات وأيام التأخر كما هي في ملفك.' },
  { icon: Undo2, title: 'تراجع بضغطة واحدة', text: 'لو ما أعجبتك النتيجة، تتراجع عن الدفعة كاملة وتعود بياناتك كما كانت تماماً.' },
];

export const LandingMigration = ({ landing, navigate }) => (
  <section id="migration" className="mx-auto max-w-7xl px-5 py-20 md:py-28" data-testid="landing-migration">
    <Reveal>
      <div className="overflow-hidden rounded-3xl border border-emerald-500/20 bg-gradient-to-bl from-emerald-500/[0.08] via-[#0A192F]/60 to-transparent p-7 sm:p-10">
        <div className="grid gap-8 lg:grid-cols-5 lg:items-center">
          <div className="lg:col-span-3">
            <span className="inline-flex items-center gap-2 rounded-full border border-emerald-500/30 bg-emerald-500/10 px-3 py-1 text-[11px] font-bold text-emerald-300">
              <FileSpreadsheet className="h-3.5 w-3.5" /> نقل البيانات
            </span>
            <h2 className="font-display mt-4 text-2xl font-bold text-white sm:text-3xl" data-testid="landing-migration-title">
              {landing?.migration_title || 'بياناتك في Excel؟ ننقلها لك في دقائق'}
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-slate-300 sm:text-base">
              {landing?.migration_subtitle || 'ارفع ملف الأكاديمية كما هو — بكل أوراقه وفئاته — ونتولّى إنشاء اللاعبين والفئات والاشتراكات والمدفوعات، مع معاينة كاملة وإمكانية التراجع.'}
            </p>
            <button
              onClick={() => navigate('/register')}
              className="group mt-7 inline-flex items-center gap-2 rounded-full bg-emerald-500 px-6 py-3 text-sm font-bold text-white transition-all hover:-translate-y-0.5 hover:bg-emerald-400"
              data-testid="landing-migration-cta"
            >
              ابدأ وانقل بياناتك
              <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
            </button>
          </div>

          <div className="space-y-3 lg:col-span-2">
            {POINTS.map((p, i) => (
              <div key={i} className="flex items-start gap-3 rounded-xl border border-white/10 bg-white/[0.03] p-4" data-testid={`landing-migration-point-${i}`}>
                <p.icon className="mt-0.5 h-4 w-4 flex-shrink-0 text-emerald-300" />
                <div>
                  <div className="font-display text-sm font-bold text-white">{p.title}</div>
                  <p className="mt-1 text-xs leading-relaxed text-slate-400">{p.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Reveal>
  </section>
);

export default LandingMigration;
